export default "__VITE_ASSET__C2T2Q1WE__"